import { Alert, AttachmentCommonUpload, Col, InputField, Label, Row, Tooltip } from "client/CommonComponents";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import TagInput from "client/CommonComponents/Tags";
import { CONSTANTS } from "client/utils/constants";

const SendEmailToVendor = (props: any) => {
    const {
        poVendorEmailDetails,
        userDetails,
        onFieldChange,
        onEmailAddressFieldChange,
        itemDetails,
        attachmentsList,
        list,
        attachmentError,
        setList,
        setAttachmentError,
        onUploadClick,
        onRemoveClick,
        sendEmailError,
        isEmailSentAlert,
        dismissMailAlert,
        isPoVendorEmailSent,
        onBccInputChange,
        bccInputChange,
        onToInputChange,
        toInputChange,
        Popupcontent,
        hideDialog,
        popupOutlinebtnOnclick
    } = props;

    const tagValuecall = (tagValue?: any) => {
        return tagValue?.map((tag?: any, index?: any) => (
            <div key={index}>
                {tag}{tagValue?.length == index + 1 ? "" : ', '}
            </div>
        ));
    }

    return (
        <>
            <Row>
                <Col>
                    <p className="label">Email Subject: <span className="DetailsText">{poVendorEmailDetails?.emailSubject}</span></p>
                </Col>
                <Col>
                <p className="label">From: <span className="DetailsText">{userDetails?.emailId}</span></p>
                </Col>
                <Col className={"mt-2 mb-2"}>
                    <Label required data-attribute="SendEmailToVendor_Default_Label">{'To: ' + '(Vendor Email Address)'}</Label>
                    <Tooltip content={poVendorEmailDetails?.toEmailAddress ? tagValuecall(poVendorEmailDetails?.toEmailAddress) : null}  data-attribute="SendEmailToVendor_Default_Tooltip">
                        <TagInput
                            value={poVendorEmailDetails?.toEmailAddress ? poVendorEmailDetails?.toEmailAddress : []}
                            onChange={(e?: any, item?: any) => onEmailAddressFieldChange(e, item, 'toEmailAddress')}
                            addOnBlur={(e?: any, item?: any) => onEmailAddressFieldChange(e, item, 'toEmailAddress')}
                            name='toEmailAddress'
                            inputProps={{
                                className: 'react-tagsinput-input',
                                placeholder: "Enter To Email Address"
                            }}
                            onlyUnique={true}
                            onChangeInput={(value: any) => onToInputChange(value)}
                            inputValue={toInputChange} />
                    </Tooltip>
                    {sendEmailError?.toEmailError?.length > 0 ? <p className='validMessage'>{sendEmailError?.toEmailError}</p> : null}
                </Col>
                <Col>
                    <Label data-attribute="SendEmailToVendor_Default_Label_2">{'BCC: ' + '(Email Address)'}</Label>
                    <Tooltip content={poVendorEmailDetails?.bccEmailAddress ? tagValuecall(poVendorEmailDetails?.bccEmailAddress) : null}  data-attribute="SendEmailToVendor_Default_Tooltip_2">
                        <TagInput
                            value={poVendorEmailDetails?.bccEmailAddress ? poVendorEmailDetails?.bccEmailAddress : []}
                            onChange={(e?: any, item?: any) => onEmailAddressFieldChange(e, item, 'bccEmailAddress')}
                            addOnBlur={(e?: any, item?: any) => onEmailAddressFieldChange(e, item, 'bccEmailAddress')}
                            name="bccEmailAddress"
                            inputProps={{
                                className: 'react-tagsinput-input',
                                placeholder: "Enter BCC Email Address"
                            }}
                            onlyUnique={true}
                            onChangeInput={(value: any) => onBccInputChange(value)}
                            inputValue={bccInputChange} />
                    </Tooltip>
                    {sendEmailError?.bccEmailError?.length > 0 ? <p className='validMessage'>{sendEmailError?.bccEmailError}</p> : null}
                </Col>
                <Col>
                    <div className="bulkorder-linkAttachmentAlign">
                        <AttachmentCommonUpload
                            link={true}
                            list={list}
                            uploadedList={attachmentsList}
                            setList={setList}
                            multiple={true}
                            uploadBtnClick={onUploadClick}
                            error={attachmentError}
                            setError={setAttachmentError}
                            maxSize={5}
                            onRemove={onRemoveClick}
                            tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                            iAttachmentEditable={true}
                            targetId={`attachements-${itemDetails.itemId?.toString()}`}
                            isDownloadable={true}
                         data-attribute="SendEmailToVendor_Default_AttachmentCommonUpload" /></div>
                </Col>
                <Col className="EmailBodyDiv">
                    <Label required data-attribute="SendEmailToVendor_Default_Label_3">Email Body</Label>
                    <InputField
                        row={6}
                        multiline={true}
                        resizable={false}
                        name='emailBody'
                        value={poVendorEmailDetails?.emailBody}
                        onChange={onFieldChange}  data-attribute="SendEmailToVendor_emailBody_Input" />
                    {sendEmailError?.bodyEmailError?.length > 0 ? <p className='validMessage'>{sendEmailError?.bodyEmailError}</p> : null}
                </Col>
            </Row>
            {isEmailSentAlert != null && !isPoVendorEmailSent?.isValid && itemDetails?.fleetRequestDetailId == isEmailSentAlert?.fleetRequestDetailId ?
                <div className="vehicle-request-stepper"><Alert
                    className="alert-message-stepper"
                    showAlert={isEmailSentAlert?.showAlert}
                    dismissAlert={dismissMailAlert}
                    type={isEmailSentAlert?.type}
                    text={isEmailSentAlert?.text}
                 data-attribute="SendEmailToVendor_Default_Alerts" /></div>
                : null}
            <CancelConfirmationPopup
                hideDialog={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={popupOutlinebtnOnclick}
                onDismiss={popupOutlinebtnOnclick}
            />
        </>

    );
};

export default SendEmailToVendor;
